<script setup>

import { ref, inject, watch } from 'vue';
import { 
	apiModifierInfosDimension,
	apiSupprimerChamps } from '@/services/ServiceModele.js';
import SelecteurTypeDonnee from '@/components/generiques/SelecteurTypeDonnee.vue';
import SelecteurModeEvaluation from '@/components/generiques/SelecteurModeEvaluation.vue';
import FormuleAffichee from '@/components/generiques/FormuleAffichee.vue';

const { dimension } = defineProps({
  dimension: Object
});

const appelerApiModifModele = inject('appelerApiModifModele');
const getTypeDonnee = inject('getTypeDonnee');
const afficherBarreFlottante = inject('afficherBarreFlottante');
const ouvrirFenetreFormule = inject('ouvrirFenetreFormule');

const infosDimension = ref(getInfosDimension(dimension));
const boutonMenu = ref(null);

watch(() => getInfosDimension(dimension), (infos) => {
	infosDimension.value = infos;
});

const itemsMenu = [
	{
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	}
];

function getInfosDimension(dimension) {
	if (!dimension) {
		return null;
	}
    return {
        id: dimension.id,
        idTypeObjet: dimension.idTypeObjet,
        nom: dimension.nom,
        nomVariable: dimension.nomVariable,
        typeDonnee: getTypeDonnee(dimension.typeDonnee),
        modeEvaluation: dimension.modeEvaluation
    };
}

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function reinitialiserValeurs() {
	infosDimension.value = getInfosDimension(dimension);
}

function modifierNom() {
	appelerApiModifModele(apiModifierInfosDimension, infosDimension.value, (reponseOK) => {
		if (reponseOK) {
			reinitialiserValeurs();
		}
	});
}

function modifierNomVariable() {
	appelerApiModifModele(apiModifierInfosDimension, infosDimension.value, (reponseOK) => {
		if (reponseOK) {
			reinitialiserValeurs();
		}
	});
}

function modifierTypeDonnee() {
	appelerApiModifModele(apiModifierInfosDimension, infosDimension.value, (reponseOK) => {
		if (reponseOK) {
			reinitialiserValeurs();
		}
	});
}

function modifierModeEvaluation(modeEvaluation) {
	appelerApiModifModele(apiModifierInfosDimension, infosDimension.value, (reponseOK) => {
		reinitialiserValeurs();
		if (reponseOK && modeEvaluation === 'CALCUL') {
			ouvrirFenetreFormule(dimension, true);
		}
	});
}

function supprimer() {
	appelerApiModifModele(apiSupprimerChamps, [dimension]);
}

</script>

<template>
	<div class="detail-dimension">
		<label class="intitule">Nom :</label>
		<div class="zone-nom">
			<input type="text" class="saisie-nom" spellcheck="false" 
				v-model="infosDimension.nom" 
				@keyup.enter="modifierNom()"
				@blur="reinitialiserValeurs" />
			<button class="bouton fa-solid fa-caret-down" 
				ref="boutonMenu"
				@click.stop="basculerAffichageMenu" />
		</div>
		<label class="intitule">Nom de variable :</label>
		<input type="text" spellcheck="false" 
			v-model="infosDimension.nomVariable" 
			@keyup.enter="modifierNomVariable()"
			@blur="reinitialiserValeurs" />
		<label class="intitule">Type :</label>
		<SelecteurTypeDonnee 
			v-model:typeDonnee="infosDimension.typeDonnee" 
			:proposer-types-objets="false" 
			:desactive="false"
			@modification="modifierTypeDonnee"
			@blur="reinitialiserValeurs" />
		<label class="intitule">Mode :</label>
		<SelecteurModeEvaluation 
		  v-model:modeEvaluation="infosDimension.modeEvaluation" 
		  @modification="modifierModeEvaluation"
		  @blur="reinitialiserValeurs" />
		<template v-if="dimension.formule">
			<label class="intitule">Formule :</label>
			<div
				class="zone-apercu-formule"
				:class="{'formule-en-erreur': dimension.formuleEnErreur}"
				@click="ouvrirFenetreFormule(dimension)">
				<FormuleAffichee :formule="dimension?.formule" class="apercu-formule" />
			</div>
		</template>
	</div>
</template>

<style scoped>

.detail-dimension {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	margin-top: 10px;
	margin-bottom: 20px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

</style>